<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: { type: Array, default: () => [] },
});

const groupedReactions = computed(() => {
  return Object.values(
    props.reactions.reduce((groups, reaction) => {
      const group = groups[reaction.emoji] ?? {
        emoji: reaction.emoji,
        count: 0,
        actorNames: [],
      };

      group.count += 1;
      if (reaction.actorName) group.actorNames.push(reaction.actorName);
      groups[reaction.emoji] = group;
      return groups;
    }, {})
  );
});
</script>

<template>
  <div class="flex flex-wrap gap-1 px-1 pt-1">
    <span
      v-for="reaction in groupedReactions"
      :key="reaction.emoji"
      :title="reaction.actorNames.join(', ')"
      class="inline-flex min-w-7 items-center justify-center gap-1 rounded-full border border-n-weak bg-n-surface-2 px-1.5 py-0.5 text-sm text-n-slate-12 shadow-sm"
    >
      <span>{{ reaction.emoji }}</span>
      <span v-if="reaction.count > 1" class="text-xs text-n-slate-11">
        {{ reaction.count }}
      </span>
    </span>
  </div>
</template>
